import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgxAngularQueryBuilderModule } from 'ngx-angular-query-builder';

import { EventsSharedModule } from 'app/events/events-shared.module';
import { FieldSharedModule } from 'app/field-shared/field-shared.module';
import { QueryCommonModule } from 'app/query-common/query-common.module';
import { EntityCoreModule } from 'entity/entity-core.module';
import { SharedModule } from 'shared/shared.module';

import { QueryFilterPillsComponent } from './filter-pills/query-filter-pills.component';
import { QueryEditComponent } from './simple-query/query-edit/query-edit.component';
import { QueryEditDialog } from './simple-query/query-edit/query-edit.dialog';
import { QueryListComponent } from './simple-query/query-list/query-list.component';
import { QueryListDialog } from './simple-query/query-list/query-list.dialog';
import {
  QuerySaveComponent, QuerySaveDialogComponent
} from './simple-query/query-save/query-save.component';
import {
  SimpleQueryAddressInputComponent
} from './simple-query/inputs/simple-query-address-input.component';
import {
  SimpleQueryAssessmentDateInputComponent
} from './simple-query/inputs/simple-query-assessment-date-input.component';
import {
  SimpleQueryBeforeAfterDateInputComponent
} from './simple-query/inputs/simple-query-before-after-date-input.component';
import { SimpleQueryBuilderComponent } from './simple-query/simple-query-builder.component';
import {
  SimpleQueryButtonGroupInputComponent
} from './simple-query/inputs/simple-query-button-group-input.component';
import {
  SimpleQueryCanvassStatusInputComponent
} from './simple-query/inputs/simple-query-canvass-status-input.component';
import { SimpleQueryContainerComponent } from './simple-query/simple-query-container.component';
import {
  SimpleQueryElectoralDistrictInputComponent
} from './simple-query/inputs/simple-query-electoral-district.component';
import { SimpleQueryEmailInputComponent } from './simple-query/inputs/simple-query-email-input.component';
import {
  SimpleQueryFilterGroupInputComponent
} from './simple-query/inputs/simple-query-filter-group-input.component';
import {
  SimpleQueryMatMultiselectInputComponent
} from './simple-query/inputs/simple-query-mat-multiselect-input.component';
import { SimpleQueryNameInputComponent } from './simple-query/inputs/simple-query-name-input.component';
import {
  SimpleQueryPersonLocationInputComponent
} from './simple-query/inputs/simple-query-person-location.component';
import { SimpleQueryPhoneInputComponent } from './simple-query/inputs/simple-query-phone-input.component';
import {
  SimpleQuerySingleSelectInputComponent
} from './simple-query/inputs/simple-query-single-select-input.component';
import {
  SimpleQuerySocialInputComponent
} from './simple-query/inputs/simple-query-social-input.component';
import {
  SimpleQueryUserAutocompleteInputComponent
} from './simple-query/inputs/simple-query-user-autocomplete.component';
import {
  SimpleQueryFollowUpFlagInputComponent
} from './simple-query/inputs/simple-query-follow-up-flag-input.component';
import { SimpleQueryEventsComponent } from './simple-query/inputs/simple-query-events.component';
import { SavedQueryBoxComponent } from './simple-query/saved-query-box/saved-query-box/saved-query-box.component';

@NgModule({
  imports: [
    SharedModule,
    FieldSharedModule,
    RouterModule,
    EntityCoreModule,
    EventsSharedModule,
    NgxAngularQueryBuilderModule,
    QueryCommonModule
  ],
  declarations: [
    SimpleQueryNameInputComponent,
    SimpleQueryCanvassStatusInputComponent,
    SimpleQueryFilterGroupInputComponent,
    SimpleQueryAssessmentDateInputComponent,
    SimpleQueryContainerComponent,
    SimpleQueryPhoneInputComponent,
    SimpleQuerySocialInputComponent,
    SimpleQueryEmailInputComponent,
    SimpleQueryAddressInputComponent,
    SimpleQueryBuilderComponent,
    SimpleQueryButtonGroupInputComponent,
    SimpleQuerySingleSelectInputComponent,
    SimpleQueryMatMultiselectInputComponent,
    SimpleQueryBeforeAfterDateInputComponent,
    SimpleQueryUserAutocompleteInputComponent,
    SimpleQueryPersonLocationInputComponent,
    SimpleQueryElectoralDistrictInputComponent,
    SimpleQueryEventsComponent,
    SimpleQueryFollowUpFlagInputComponent,
    SavedQueryBoxComponent,
    QueryFilterPillsComponent,
    QuerySaveComponent,
    QuerySaveDialogComponent,
    QueryEditComponent,
    QueryEditDialog,
    QueryListComponent,
    QueryListDialog
  ],
  exports: [
    SimpleQueryNameInputComponent,
    SimpleQueryCanvassStatusInputComponent,
    SimpleQueryFilterGroupInputComponent,
    SimpleQueryContainerComponent,
    SimpleQueryPhoneInputComponent,
    SimpleQuerySocialInputComponent,
    SimpleQueryEmailInputComponent,
    SimpleQueryAddressInputComponent,
    SimpleQueryBuilderComponent,
    SimpleQueryButtonGroupInputComponent,
    SimpleQuerySingleSelectInputComponent,
    SimpleQueryMatMultiselectInputComponent,
    SimpleQueryBeforeAfterDateInputComponent,
    SimpleQueryUserAutocompleteInputComponent,
    SimpleQueryPersonLocationInputComponent,
    SimpleQueryElectoralDistrictInputComponent,
    SavedQueryBoxComponent,
    QueryFilterPillsComponent,
    QuerySaveComponent,
    QuerySaveDialogComponent,
    QueryEditComponent,
    QueryEditDialog,
    QueryListComponent,
    QueryListDialog
  ],
  providers: [
  ]
})
export class QueryModule { }
